export const RECEIPT_CONFIG = {
  PRINT_DELAY_MS: 500,
  CLOSE_DELAY_MS: 500,
  CONFIRM_DIALOG_DELAY_MS: 1000,
  RECEIPT_WIDTH_PX: 336,
  RECEIPT_MARGIN_PX: 96,
  DIALOG_WIDTH: '90vw',
  DIALOG_MAX_WIDTH: '500px',
  TOAST_DURATION_MS: 3000,
  WEBSOCKET: {
    RECONNECTION_ATTEMPTS: 5,
    RECONNECTION_DELAY_MS: 3000
  }
}
